import React from 'react';
import { useParams } from 'react-router-dom';
import { GradingSplitPane } from 'components/result/GradingSplitPane';

/** The same split-pane as ManualGrading, scoped to a single test. */
const TestReviews: React.FC = () => {
  const { testId } = useParams();
  return <GradingSplitPane testId={testId} />;
};

export default TestReviews;
